import { Clock } from 'lucide-react'
import { EstablishmentFields } from '@/components/features/timeTracking/EstablishmentFields'
import { emptySetupConfig, saveSetup, setupErrorsFromApi, validateSetup } from '@/components/features/timeTracking/timeTrackingUtils'
import { sdk } from '@/lib/sdk'
import type { TimeTrackingSetupConfig } from '@/types/timeTracking'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const TimeTrackingPage = lazyPage(() => import('@/pages/TimeTracking'), 'TimeTrackingPage')

export const timeTrackingModule: ModuleDefinition = {
  key: 'timeTracking',
  icon: Clock,
  iconName: 'clock',
  namespaces: ['timeTracking'],
  ready: true,
  /* One place per establishment: the wizard lands on it. No "one or many" step (F-51 criterion 1). */
  opensOnCreate: true,
  ListPage: TimeTrackingPage,
  /* The employer the punches belong to has a body of its own: a step after the details (PADROES-UI section 14). */
  setup: {
    wizardStep: 'own',
    stepLabelKey: 'timeTracking:establishment.step',
    stepHintKey: 'timeTracking:establishment.stepHint',
    defaultConfig: () => emptySetupConfig(),
    validate: (config, t) => validateSetup(config as TimeTrackingSetupConfig, t),
    Fields: EstablishmentFields,
    persist: {
      type: 'endpoint',
      save: (spaceId, config) => saveSetup(spaceId, config as TimeTrackingSetupConfig),
      load: async (spaceId) => {
        const space = await sdk.timeTracking.getSpace(spaceId)
        /* The employer is the management's (owner, admin, finance); the server says who that is. */
        if (!space.canManage) return null
        const linked = space.establishment?.id || null
        return linked ? { ...emptySetupConfig(), mode: 'existing', establishmentId: linked, linkedEstablishmentId: linked } : emptySetupConfig()
      },
      errorsFromSaveFailure: (err) => setupErrorsFromApi(err)
    }
  }
}
